export default __webpack_public_path__ + "static/media/screen6.be9825d6.png";